<template>
    <h2 class="heading">Event Log Form</h2>
    <div class="form">
        <el-form :model="event" label-width="250px" style="width:800px" >
            <el-form-item label="Name of activity" required>
                <el-input v-model="event.activityName" minlength="2" maxlength="300" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Date of activity" required>
                <el-date-picker v-model="event.activityDate" type="date" placeholder="Date of activity" value-format="YYYY-MM-DD"/>
            </el-form-item>
            <el-form-item label="City" required>
                <el-input v-model="event.city" maxlength="50" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Media name" required>
                <el-input v-model="event.mediaName" maxlength="150" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Nature" required>
                <el-select v-model="event.type" placeholder="Select nature" style="width:220px">
                    <el-option v-for="t in types" :key="t" :label="t" :value="t"/>
                </el-select>
                <el-input v-model="type" v-if="event.type=='Others'" placeholder="Others please specify"
                    style="width:290px; margin-left:10px;" maxlength="50" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Arranged by" required>
                <el-select v-model="event.internalLead" placeholder="Select arranged by" style="width:220px">
                    <el-option v-for="leader in leaders" :key="leader" :label="leader" :value="leader"/>
                </el-select>
                <el-input v-model="internalLead" v-if="event.internalLead=='Others'" placeholder="Others please specify"
                    style="width:290px; margin-left:10px;" maxlength="100" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Speakers" required>
                <el-select v-model="event.speaker" placeholder="Select speaker" style="width:220px">
                    <el-option v-for="speaker in speakers" :key="speaker" :label="speaker" :value="speaker"/>
                </el-select>
                <el-input v-model="speaker" v-if="event.speaker=='Others'" placeholder="Others please specify"
                    style="width:290px; margin-left:10px;" maxlength="100" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Other attendees">
                <el-input v-model="event.keyAttendees" maxlength="100" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Nature of participation" required>
                <el-select v-model="event.attendeeRole" placeholder="Select nature of participation" style="width:220px">
                    <el-option v-for="role in attendeeRoles" :key="role" :label="role" :value="role"/>
                </el-select>
                <el-input v-model="attendeeRole" v-if="event.attendeeRole=='Others'" placeholder="Others please specify"
                    style="width:290px; margin-left:10px;" maxlength="100" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Topic" required>
                <el-input v-model="event.topic" type="textarea" maxlength="1000" row="4" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Talking points">
                <el-input v-model="event.talkingPoints" type="textarea" maxlength="30000" row="6" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Costs if applicable">
                <el-input v-model="event.costs" maxlength="1000" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Addional notes">
                <el-input v-model="event.remarks" maxlength="150" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Description">
                <el-input v-model="event.description" type="textarea" maxlength="1000" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Attachment">
                <div v-if="files.indexOf(':') > -1" style="display:block;">
                    <el-tag v-for="item in files.split(';')" :key="item" @close="removeFile(item)" closable>
                        <a v-if="item.length" href="" @click.prevent="global.down(item.split(':')[1], item.split(':')[0])">{{item.split(':')[0]}}</a>
                    </el-tag>
                </div>
                <el-upload :action="global.upload_path" multiple :on-success="uploaded" :data="{type:'log', subType:'event'}" :show-file-list="false" >
                    <el-button type="primary" plain>Browse</el-button>
                </el-upload>
            </el-form-item>
            
            <el-form-item label="">
                <el-button type="primary" @click="submitEvent">Submit</el-button>
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
                <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                    <img src="@/assets/loading.gif" style="height:24px;"/>
                </span>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
const types = ["Panel", "Presentation", "Networking event", "Private lunch", "Video", "Panel Discussion", "Summit", 
               "Seminar", "Conference", "Premia event", "Media event", "Trading event", "Round tables", "Webinar", "Others"];
const leaders = ["Rebecca", "David", "Laura", "Frederick", "Others"];
const speakers = ["Rebecca", "David", "Laura", "Frederick", "Others"];
const attendeeRoles = ["Panellist", "Speaker", "Speaker / Panellist", "Participant", "Keynote speaker", "Host / Speaker", 
                       "Workshops Speaker", "Lead Speaker", "Presenter", "Networking partner", "Interviewer", "Others"]
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            types, leaders, speakers, attendeeRoles,
            speaker: '', type: '', attendeeRole: '', internalLead: '',
            event: {
                id: null,
                activityName: '',
                activityDate: '',
                city: '',
                mediaName: '',
                type: '',
                internalLead: '',
                speaker: '',
                keyAttendees: '',
                attendeeRole: '',
                topic: '',
                talkingPoints: '',
                costs: '',
                remarks: '',
                description: '',
                attachment: '',
            },
            loading: false,
            files: '',
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "event";
        let code = this.$route.query ? this.$route.query.code : null;
        if (code) {
            let result = await AXIOS("/log/getEventByCode", {code: code});
            if (result.success) {
                this.event = result.data;
                if (this.event.attachment.indexOf(":")>-1)
                    this.files = this.event.attachment;
                if (types.indexOf(this.event.type) == -1) {
                    this.type = this.event.type;
                    this.event.type = "Others";
                }
                if (leaders.indexOf(this.event.internalLead) == -1) {
                    this.internalLead = this.event.internalLead;
                    this.event.internalLead = "Others";
                }
                if (speakers.indexOf(this.event.speaker) == -1) {
                    this.speaker = this.event.speaker;
                    this.event.speaker = "Others";
                }
                if (attendeeRoles.indexOf(this.event.attendeeRole) == -1) {
                    this.attendeeRole = this.event.attendeeRole;
                    this.event.attendeeRole = "Others";
                }
            } else {
                this.errMsg = result.errMsg;
            }
        }
    },
    methods: {
        uploaded(response) {
            let files = response.length ? response[0].name + ":" + response[0].url : '';
            if (files != '' && this.files.indexOf(files) == -1) {
                this.files = (this.files == '') ? files : this.files + ";" + files;
            }
        },
        removeFile(item) {
            this.files = this.files + ";"
            this.files = this.files.replace(item+";", "");
            if (this.files.endsWith(";"))
                this.files = this.files.substring(0, this.files.length-1);
        },
        async submitEvent() {
            this.errMsg = "";
            if (this.event.activityName == "") {
                this.errMsg = "[Name of activity] is required"; return;
            }
            if (this.event.activityDate == "") {
                this.errMsg = "[Activity date] is required"; return;
            }
            if (this.event.city == "") {
                this.errMsg = "[City] is required"; return;
            }
            if (this.event.mediaName == "") {
                this.errMsg = "[Media name] is required"; return;
            }
            if (this.event.type == "" && this.type == "") {
                this.errMsg = "[Nature] is required"; return;
            }
            if (this.event.type == "Others" && this.type == "") {
                this.errMsg = "Please specify other nature"; return;
            }
            if (this.event.internalLead == "" && this.internalLead == "") {
                this.errMsg = "[Arranged by] is required"; return;
            }
            if (this.event.internalLead == "Others" && this.internalLead == "") {
                this.errMsg = "Please specify other arranged by"; return;
            }
            if (this.event.speaker == "" && this.speaker == "") {
                this.errMsg = "[Speaker] is required"; return;
            }
            if (this.event.speaker == "Others" && this.speaker == "") {
                this.errMsg = "Please specify other speaker"; return;
            }
            if (this.event.attendeeRole == "" && this.attendeeRole == "") {
                this.errMsg = "[Nature of participation] is required"; return;
            }
            if (this.event.attendeeRole == "Others" && this.attendeeRole == "") {
                this.errMsg = "Please specify other nature of participation"; return;
            }
            if (this.event.topic == "") {
                this.errMsg = "[Topic] is required"; return;
            }
            if (this.event.type == "Others") this.event.type = this.type;
            if (this.event.internalLead == "Others") this.event.internalLead = this.internalLead;
            if (this.event.speaker == "Others") this.event.speaker = this.speaker;
            if (this.event.attendeeRole == "Others") this.event.attendeeRole = this.attendeeRole;
            this.event.attachment = this.files;

            if (this.loading) return; // avoid repeat submit
            this.loading = true;
            let result = await AXIOS("/log/saveEvent", this.event);
            if (result.success) {
                this.$router.push("/log/myEventList");
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .heading {
        width:900px;
    }
    .errMsg {
        padding-left:10px;
    }
</style>